import { useTranslation } from 'react-i18next';
import { cn } from '@/shared/lib/cn';

interface TrialStatusBadgeProps {
  trialStatus: string | null;
  subscriptionStatus: string;
  className?: string;
}

export function TrialStatusBadge({
  trialStatus,
  subscriptionStatus,
  className,
}: TrialStatusBadgeProps) {
  const { t } = useTranslation();

  if (!trialStatus) {
    return <span className={cn('text-xs text-muted-foreground', className)}>—</span>;
  }

  const key = `monitor.trialStatus.${trialStatus}` as const;
  const label = t(key, { defaultValue: trialStatus });

  const tone =
    trialStatus === 'trialing' || subscriptionStatus === 'trialing'
      ? 'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400'
      : trialStatus === 'trial_ended' || trialStatus === 'expired'
        ? 'bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-400'
        : 'bg-gray-100 text-gray-700 dark:bg-gray-800 dark:text-gray-300';

  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium',
        tone,
        className,
      )}
    >
      {label}
    </span>
  );
}
